import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from "react-router-dom";

type Props = {};

export const UnauthenticatedRoute: React.FC<React.PropsWithChildren<Props>> = ({
	children,
}) => {
	const { data, isLoading } = useUserInfoQuery();

	if (isLoading) return <div />;

	if (data?.status === 200) {
		console.log("User is authenticated, redirecting to configurations");
		return <Navigate to={AppRouting.Configurations.path()} replace />;
	}

	return (
		<ErrorBoundary FallbackComponent={ApplicationErrorPage}>
			{children}
		</ErrorBoundary>
	);
};
